var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(-535 -477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    transform: "translate(535 477)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "event",
    transform: "translate(544 485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M20.951,13.581V3.809a1.907,1.907,0,0,0-1.9-1.9H16.666a.476.476,0,0,0-.476.476V4.762a.952.952,0,1,1-1.269-.892.477.477,0,0,0,.316-.449V.476a.476.476,0,1,0-.952,0V1.9H7.142a.476.476,0,0,0-.476.476V4.762A.952.952,0,1,1,5.4,3.87a.477.477,0,0,0,.316-.449V.476a.476.476,0,1,0-.952,0V1.9H1.9A1.907,1.907,0,0,0,0,3.809V19.047a1.907,1.907,0,0,0,1.9,1.9H13.581a5.236,5.236,0,1,0,7.37-7.37Zm-3.333,7.37a.476.476,0,1,1,.476-.476A.476.476,0,0,1,17.618,20.951Zm.476-2.381a.476.476,0,1,1-.952,0V14.761a.476.476,0,0,1,.952,0V18.57Zm.952-5.987a5.224,5.224,0,0,0-6.463,6.463H1.9V7.619H19.047Z",
    fill: "#3e3e3e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.73b3cfb0ce75561d9cd4c7af566f137a.svg";
export { ForwardRef as ReactComponent };